import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Container } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TextField, Typography } from '@material-ui/core';

import { genfunction } from 'helpers'
import {
    actionStartAppLoader, actionEndAppLoader, actionGetProductsByTypeAndDisplayAreas,
    actionShopCartUpdateDonationProduct, actionGetDisplayAreasByIdAndType,
    actionResetPaymentTransaction
} from 'actions';
import { ErrorHandling, Title } from 'components';
import DonationProduct from './components/DonationProduct'

const { OrderItemsInCartError } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    }
}));

const DonationProducts = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");
    const [displayArea, setDisplayArea] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [viewProducts, setViewProducts] = useState([]);
    const [note, setNote] = useState("");

    const cartDonationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    const products = useSelector(state => state.reducerProduct.products);
    const loading = useSelector(state => state.reducerProduct.loading);
    const error = useSelector(state => state.reducerProduct.error);

    const displayAreas = useSelector(state => state.reducerDisplayAreas.displayAreas);
    const displayAreasLoading = useSelector(state => state.reducerDisplayAreas.loading);
    const displayAreasError = useSelector(state => state.reducerDisplayAreas.displayAreasError);

    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const events = useSelector(state => state.reducerShopCart.events);
    const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    useEffect(() => {
        var areaNo = props.match.params.id;
        if (isDisplayAreaExists(areaNo))
            actionGetProductsByTypeAndDisplayAreas(dispatch, "donationpage", areaNo);
    }, [displayAreas])

    useEffect(() => {
        if (products && products.length > 0) {
            setItemIntoView();
        }
    }, [products])

    useEffect(() => {
        if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
            giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        if (props.match.path == "/donation/Area/:id") {
            var areaNo = props.match.params.id;
            if (isDisplayAreaExists(areaNo) == false) {
                actionGetDisplayAreasByIdAndType(dispatch, areaNo, "donationpage");
            }
        }
        else {
            props.history.push('/not-found');
        }
    }, [])

    useEffect(() => {
        if (loading || displayAreasLoading)
            actionStartAppLoader(dispatch);
        else
            actionEndAppLoader(dispatch);
    }, [loading, displayAreasLoading])

    useEffect(() => {
        if (displayAreasError && displayAreasError != "")
            seterrorMsg(displayAreasError)
        else if (error && error != "")
            seterrorMsg(error);
    }, [error, displayAreasError])

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const isDisplayAreaExists = (areaNo) => {
        let displayArea;
        if (displayAreas)
            displayArea = displayAreas.find(area => area.DisplayAreaNo == areaNo);

        if (displayArea)
            setDisplayArea(displayArea)

        return displayArea != undefined;
    }

    const getTotalAmount = () => {
        let total = 0;
        selectedProducts.forEach(product => {
            total += product.Amount;
        });
        return total;
    }

    const onChangeDonationProductSelection = (product) => {
        AddProductToList(product);
    }

    const AddProductToList = (product) => {
        let donationProducts = [...selectedProducts];
        donationProducts = donationProducts.filter(x => x.ProductID != product.ProductID);
        if (IsValidProduct(product))
            donationProducts.push(product);
        setSelectedProducts(donationProducts);
    }

    const IsValidProduct = (product) => {
        let p = products.find(x => x.ProductID == product.ProductID);
        if (p) {
            if (product.DisplayAmount == "")
                return false;
            if (product.DisplayAmount != "other")
                return true;
            else if (product.Amount >= p.OtherValue[0].MinAmount && product.Amount <= p.OtherValue[0].MaxAmount)
                return true;
        }
        return false;
    }

    const onClickContinueButtonHandler = () => {
        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }
        else if (selectedProducts.length == 0) {
            seterrorMsg("Please select item first");
            return;
        }

        let newselectedProducts = [...selectedProducts];
        if (note != "")
            newselectedProducts.forEach(product => {
                product.ProductNotes = note;
            });

        actionShopCartUpdateDonationProduct(dispatch, newselectedProducts);
        props.history.push('/checkout');
    }

    const setItemIntoView = () => {
        let items = [...products];
        cartDonationProducts.forEach(cartItem => {
            let existItem = items.find(x => x.ProductID == cartItem.ProductID)
            if (existItem) {
                existItem.DisplayAmount = cartItem.DisplayAmount;
                existItem.Amount = cartItem.Amount
            }
        });

        let selectedItem = items.filter(x => x.DisplayAmount).map(item => {
            return getNewProductObj(item)
        })
        setSelectedProducts(selectedItem);
        setViewProducts(items);
    }

    const getNewProductObj = (product) => {
        let prod = {
            ProductID: product.ProductID,
            ProductName: product.ProductName,
            DisplayArea: product.DisplayArea,
            DisplayAmount: product.DisplayAmount,
            Amount: product.Amount,
            UseAlternateMerchantOnline: product.UseAlternateMerchantOnline
        }
        return prod;
    }

    return (
        <div className={classes.root} align="center" >
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
            {displayArea && viewProducts ?
                <Grid container spacing={3} xs={12} md={8} lg={6}>
                    <Grid item xs={12}>
                        <Title Header={displayArea?.AreaName} SubTitle={displayArea?.DisplayText} />
                    </Grid>
                    <br></br>
                    <Grid container item spacing={3} align="left">
                        {viewProducts.sort((a, b) => a.SortOrder - b.SortOrder).map(product => {
                            return <Grid key={product.ProductID} item xs={12}><DonationProduct Product={product} onChangeAmount={onChangeDonationProductSelection} /></Grid>
                        })}
                    </Grid>
                    <Grid item xs={12} align="right">
                        <Typography variant='h4'>Total : {genfunction.ccyFormat(getTotalAmount())}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField value={note} onChange={(event) => { setNote(event.target.value) }}
                            minRows={4} variant="outlined" fullWidth={true} multiline={true} inputProps={{ maxLength: 256 }}></TextField>
                    </Grid>
                    <Grid item xs={12} align="right">
                        <Button color='primary' variant='contained' onClick={onClickContinueButtonHandler}>Continue</Button>
                    </Grid>
                </Grid> : <Typography variant='h4'>{errorMsg}</Typography>}
        </div>
    );
};

export default DonationProducts;
